import React from 'react';

class AgendaStatic extends React.Component {
    render() {
        return (<div>
            <h4>Rótulos</h4>
            <table id="datatable_Home" class="table table-striped">
                <thead>
                    <tr>
                        <th>Nº</th>
                        <th>Data</th>
                        <th>Entidade</th>
                        <th>Morada</th>
                        <th>Ref.</th>
                        <th>Estado</th>
                        <th>Tipo de selo</th>
                        <th>Quantidade</th>
                        <th>Capacidade</th>
                        <th>Local de entrega</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>123451</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>23413</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>431234</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>84322</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>562341</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>23413</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>51213</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>52346</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>1312334</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>521765</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>

                </tbody>
            </table>
            <h4>Marcas</h4>
            <table id="datatable_Home" class="table table-striped">
                <thead>
                    <tr>
                        <th>Nº</th>
                        <th>Data</th>
                        <th>Entidade</th>
                        <th>Morada</th>
                        <th>Ref.</th>
                        <th>Estado</th>
                        <th>Tipo de selo</th>
                        <th>Quantidade</th>
                        <th>Capacidade</th>
                        <th>Local de entrega</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>123451</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>23413</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>431234</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>84322</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>562341</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>23413</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>51213</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>52346</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>1312334</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>521765</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>

                </tbody>
            </table>
            <h4>Selos</h4>
            <table id="datatable_Home" class="table table-striped">
                <thead>
                    <tr>
                        <th>Nº</th>
                        <th>Data</th>
                        <th>Entidade</th>
                        <th>Morada</th>
                        <th>Ref.</th>
                        <th>Estado</th>
                        <th>Tipo de selo</th>
                        <th>Quantidade</th>
                        <th>Capacidade</th>
                        <th>Local de entrega</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>123451</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>23413</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>431234</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>84322</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>562341</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>23413</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>51213</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>52346</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>
                    <tr>
                        <td>1312334</td>
                        <td>02/11/2020</td>
                        <td>Vinoquel</td>
                        <td>Quinta Sra do Rosário</td>
                        <td>521765</td>
                        <td>Pendente</td>
                        <td>Selo DO/Etiq. Papel</td>
                        <td>Quantidade</td>
                        <td>Capacidade</td>
                        <td>Local de entrega</td>
                        <td><button type="button" class="btn btn-flat"><i class="icon-ivdp icon-shortcut"></i></button></td>
                    </tr>

                </tbody>
            </table>
        </div>
        );
    }
}
export default AgendaStatic;